module.exports = __webpack_public_path__ + "logo-black.87c0b047d2df669c9c91db84ab8f0877.svg";